// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:14
import { IsochroneResults_abstract } from './../abstract/SagaBase/IsochroneResults_abstract';
export class IsochroneResults extends IsochroneResults_abstract {}
